/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GlobalMonthlyGuildMember } from './GlobalMonthlyGuildMember';
import {
    GlobalMonthlyGuildMemberFromJSON,
    GlobalMonthlyGuildMemberFromJSONTyped,
    GlobalMonthlyGuildMemberToJSON,
    GlobalMonthlyGuildMemberToJSONTyped,
} from './GlobalMonthlyGuildMember';

/**
 * 
 * @export
 * @interface GetGlobalMonthlyGuildLeaderboardResponse
 */
export interface GetGlobalMonthlyGuildLeaderboardResponse {
    /**
     * 
     * @type {Array<GlobalMonthlyGuildMember>}
     * @memberof GetGlobalMonthlyGuildLeaderboardResponse
     */
    members: Array<GlobalMonthlyGuildMember>;
}

/**
 * Check if a given object implements the GetGlobalMonthlyGuildLeaderboardResponse interface.
 */
export function instanceOfGetGlobalMonthlyGuildLeaderboardResponse(value: object): value is GetGlobalMonthlyGuildLeaderboardResponse {
    if (!('members' in value) || value['members'] === undefined) return false;
    return true;
}

export function GetGlobalMonthlyGuildLeaderboardResponseFromJSON(json: any): GetGlobalMonthlyGuildLeaderboardResponse {
    return GetGlobalMonthlyGuildLeaderboardResponseFromJSONTyped(json, false);
}

export function GetGlobalMonthlyGuildLeaderboardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetGlobalMonthlyGuildLeaderboardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'members': ((json['members'] as Array<any>).map(GlobalMonthlyGuildMemberFromJSON)),
    };
}

export function GetGlobalMonthlyGuildLeaderboardResponseToJSON(json: any): GetGlobalMonthlyGuildLeaderboardResponse {
    return GetGlobalMonthlyGuildLeaderboardResponseToJSONTyped(json, false);
}

export function GetGlobalMonthlyGuildLeaderboardResponseToJSONTyped(value?: GetGlobalMonthlyGuildLeaderboardResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'members': ((value['members'] as Array<any>).map(GlobalMonthlyGuildMemberToJSON)),
    };
}

